import { DecimalPipe } from '@angular/common';
import { Component, OnChanges, OnInit, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiModulesService } from 'src/app/api-modules.service';
import { NgbdSortableHeader, SortEvent } from 'src/app/shared/directives/NgbdSortableHeader';
import { TableService } from 'src/app/shared/service/table.service';
import { LISTPAGEDB, ListPagesDB } from 'src/app/shared/tables/list-pages';

@Component({
  selector: 'app-ourchannel',
  templateUrl: './ourchannel.component.html',
  styleUrls: ['./ourchannel.component.scss'],
  providers: [TableService, DecimalPipe]
})
export class OurchannelComponent implements OnInit,OnChanges {
  public selected = [];
  public tableItem$: Observable<ListPagesDB[]>;
  public searchText;
  public editID:any;
   visible:any=true;
  total$: Observable<number>;
  public countryname:ListPagesDB[] = [];
  public  username=[];
  page = 1;
  pageSize = 10;
  constructor(private apiModulesService: ApiModulesService,public service: TableService) {
    this.tableItem$ = service.tableItem$;
    this.total$ = service.total$;
    this.service.setUserData(LISTPAGEDB);
  }

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  onSort({ column, direction }: SortEvent) 
  {
    console.log(this);
    this.headers.forEach((header) => 
    {
      if (header.sortable !== column) 
      {
        header.direction = '';
      }
    });

    this.service.sortColumn = column;
    this.service.sortDirection = direction;

  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }
      ngOnChanges(changes: SimpleChanges): void {
        this.getCountriesName();
      }
  ngOnInit() 
  {
    this.getCountriesName();
  }
  public getCountriesName(){
    
    this.apiModulesService.get("telegram/channel/owned-list").subscribe((data)=>{
      this.countryname =data;
       console.log(data);
         });
  }  
}
